import React from 'react';

type DashboardData = {
  new_emails: number;
  new_phone_numbers: number;
  email_enrichments: number;
  phone_enrichments: number;
  candidate_views: number;
  emails_removed: number;
  contacts_contacted: number;
  contact_engagement: number;
};

type Meta = {
  start: string;
  end: string;
};

type AdminDashboardProps = {
  data: DashboardData;
  meta: Meta;
};

const ReportDashboard: React.FC<AdminDashboardProps> = ({ data, meta }) => {
  const items = [
    { label: 'New Emails', value: data.new_emails },
    { label: 'New Phone Numbers', value: data.new_phone_numbers },
    { label: 'Email Enrichments', value: data.email_enrichments },
    { label: 'Phone Enrichments', value: data.phone_enrichments },
    { label: 'Candidate Views', value: data.candidate_views },
    { label: 'Emails Removed', value: data.emails_removed },
    { label: 'Contacts Contacted', value: data.contacts_contacted },
    { label: 'Contact Engagement', value: data.contact_engagement },
  ];

  return (
    <div className='p-6'>
      <h1 className='text-2xl font-bold mb-4'>Reports</h1>
      <h3 className='mb-2'>
        {meta.start} - {meta.end}
      </h3>
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
        {items.map((item) => (
          <div
            key={item.label}
            className='bg-white rounded-2xl shadow p-4 border border-gray-200'
          >
            <div className='text-gray-600 text-sm'>{item.label}</div>
            <div className='text-2xl font-semibold'>{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportDashboard;
